module.exports = __webpack_public_path__ + "static/img/01-globus.dec325b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-globus.gif
// module id = 91
// module chunks = 0